export const FETCH_FINANCIALSTATEMENT_BEGIN="FETCH_FINANCIALSTATEMENT_BEGIN";
export const FETCH_FINANCIALSTATEMENT_SUCCESS="FETCH_FINANCIALSTATEMENT_SUCCESS";
export const FETCH_FINANCIALSTATEMENT_FAILURE = "FETCH_FINANCIALSTATEMENT_FAILURE";

export const FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN = "FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN";
export const FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS = "FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS";
export const FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE = "FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE";

export const FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN="FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN";
export const FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS="FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS";
export const FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE="FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE";